import {
  Avatar,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import { getActivityLogById } from "../api/crud";
import _ from "lodash";
import axios from "axios";
import { engApi } from "../api/engApi";
import { matchOptions } from "../utils/function";
import { optionsBranch } from "../data/branch-data";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import ModalView from "../Components/ModalView";

const ActivityLog = () => {
  const profile = useSelector((state) => state.profileReducer.profile);
  const getUsername = localStorage.getItem("username");
 
  const [searchParams, setSearchParams] = useSearchParams();
  const st_id = searchParams.get("st_id");
  const [list, setList] = useState([]);
  const [listFilter, setListFilter] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalAddOpen, setModalAddOpen] = useState(false);

  //const getUsername = 63050302;
  // const getUsername = localStorage.getItem("username");

  const onHandleSearch = (ev) => {
    setSearchTerm(ev.target.value);
  };

  const onHandleGetData = (stId) => {
    getActivityLogById(stId)
      .then((res) => {
        if (res && res.length) {
          const filterList = res.filter((item) => {
            return item.type === "เข้า";
          });

          const uniq = _.uniqBy(filterList, "event_id");

          setList(uniq);
          setListFilter(uniq);
        } else {
          setList([]);
          setListFilter([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (profile && profile.m_role == "student") {
      onHandleGetData(getUsername);

      window.history.pushState({}, document.title, window.location.pathname);
    } else if (
      profile &&
      (profile.m_role == "staff" || profile.m_role == "admin")
    ) {
      onHandleGetData(st_id);
      setSearchTerm(st_id);
    }
  }, [profile]);

  const displayHeader = (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      borderBottom="1px solid gray"
      padding={2}
    >
      <Box>
        <Typography variant="h6">
          แบบบันทึกการเข้าอบรมเตรียมความพร้อมก่อนฝึกงานและสหกิจศึกษา
        </Typography>
        <Typography>คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา</Typography>
      </Box>
      <Box>
        {!!profile &&
          (profile.m_role == "staff" || profile.m_role == "admin") && (
            <>
              <TextField
                value={searchTerm}
                onChange={onHandleSearch}
                label="รหัสนิสิต"
                variant="standard"
              />
              <Button
                variant="contained"
                onClick={() => {
                  onHandleGetData(searchTerm);
                  setSearchParams({ st_id: searchTerm });
                }}
              >
                Search
              </Button>
            </>
          )}
      </Box>
    </Box>
  );

  const dispplayProfile = (
    <Box p={3} display="flex">
      <Avatar
        alt={listFilter[0]?.st_name}
        src={`http://reg.buu.ac.th/registrar/getstudentimage.asp?id=${listFilter[0]?.st_id}`}
        sx={{ width: 100, height: 100 }} />

      <Box pl={3}>
        <Typography>
          รหัสนิสิต : {listFilter[0]?.st_id} {listFilter[0]?.st_name}
        </Typography>
        <Typography>
          {matchOptions(optionsBranch, listFilter[0]?.b_id)}
        </Typography>
        <Typography>
          จำนวนที่เข้าอบรม
          <span className="ms-2 badge bg-primary">{listFilter.length}</span>
        </Typography>
      </Box>

    </Box>
    
    
   
   

  );

  const displayTable = (
   

    <table className="table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th
            scope="col"
            style={{
              maxWidth: "300px",
            }}
          ></th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        {listFilter?.map((item, index) => {
          return (
            <tr key={item.log_id}>
              <th>{index + 1}</th>
              <td
                style={{
                  maxWidth: "300px",
                }}
              >
                <Box>
                  <Typography fontSize="0.9rem" fontWeight="bold">
                    {item?.title}
                  </Typography>
                </Box>
                {!item?.expert.includes("\r\n") ? (
                  <span className="badge bg-info">{item?.expert}</span>
                ) : (
                  item?.expert.split("\r\n").map((item, index) => {
                    return (
                      <span className="badge bg-info" key={index}>
                        {item}
                      </span>
                    );
                  })
                )}
              </td>
              <td>
                {format(
                  new Date(item.checkin_date.replace(" ", "T")),
                  "dd MMM yyyy HH:mm"
                )}
              </td>
              <td>{item.comment}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  const displayModalAdd = (
    <ModalView
      isModaOpen={modalAddOpen}
      setIsModalOpen={setModalAddOpen}
      title="เพิ่มการอบรมของนิสิต"
    >
      <Box width={500} paddingY={3}>
        <form action="./add-event-register.php" method="post">
          <Grid container spacing={1}>
          <Grid item xs={12}>
              <input
                className="form-control w-100"
                name="event_id[]"
                placeholder="รหัสการอบรม"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                name="st_id[]"
                placeholder="รหัสนิสิต"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                name = "type[]"
                placeholder="ประเภท"
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                name="checkin_date[]"
                placeholder="วันเวลา"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control w-100"
                name="Comment[]"
                placeholder="Comment"
              />
            </Grid>

          </Grid>
          <Button type="submit">บันทึก</Button>
        </form>
      </Box>
    </ModalView>
  );

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {displayHeader}
          {dispplayProfile}
          {displayModalAdd}
        </Grid>
        <Grid item xs={12}>
          {displayTable}
        </Grid>
      </Grid>
      
      {!!profile &&
          (profile.m_role == "staff" || profile.m_role == "admin") && (
            <>
              
              <Button
                variant="contained"
                onClick={() => setModalAddOpen(true)}
              >
                เพิ่ม
              </Button>
            </>
          )}


    </div>
    
  );
};

export default ActivityLog;
